import {
  Box, Heading, Divider, Text, Flex, Tooltip, Button, Spinner, useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { SiMicrosoftexcel } from 'react-icons/si';



import { Link } from "react-router-dom";
import axios from 'axios'
import { Auth } from "./Auth";
import { v4 as uuid } from "uuid";
import TableToExcelCustomer from "./TableToExcelCustomer";

const CustomerDetails = ({ cData, orderData, renderXyz, kycCategory, pvtPan, showBox }) => {
  const [reportURL, setReportURL] = useState('')
  const [reportToggle, setReportToggle] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [partyCreditScore, setPartyCreditScore] = useState(null)
  const [verifyDocPan, setVerifyDocPan] = useState({})
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [manualCustomerData, setManualCustomerData] = useState({
    fullName: "",
    linkedMobileNumber: "",
  })
  const [showCreditData, setShowCreditData] = useState(false)


  // Decentro credit report data
  const bankAccount = cData.BankAccount.filter((x) => x?.verificationId === orderData?.id)
  const addresses = cData.Address.filter((y) => y?.verificationId === orderData?.id)
  const creditScoreData = cData.PartyCreditScore.filter((x) => x.verificationId === orderData?.id)

  const panDetail = cData?.PartyPanKyc[0]
  const creditScore = cData?.PartyCreditScore[0]
  
  const partyContent = [
    cData?.PartyContent.find((x) => x.contentTypeEnumId === "PAN"), 
    cData?.PartyContent.find((x) => x.contentTypeEnumId === "LINKEDIN_PROFILE")
  ]

  // facematch latest scroe
  // let filterDate = []
  // cData.PartyFaceMatch.map((x) => filterDate = [...filterDate, x.matchDate])
  // // const faceDate = filterDate.map(filterDate => new Date(filterDate)); 

  // // Find the latest date using reduce
  // const latestDate = filterDate.map(filterDate => new Date(filterDate)).reduce((maxDate, currentDate) => {
  //   return currentDate > maxDate ? currentDate : maxDate;
  // },0);

  // const facematch_score_date = cData.PartyFaceMatch.filter((n) => n.matchDate === new Date(latestDate).toISOString())



  const toast = useToast()


  // creditHandler -- fetch credit report 
  const creditHandler = () => {
    setBtnLoading(true)
    const ref_id = uuid()
    let data = JSON.stringify({
      "reference_id": `${ref_id}`,
      "consent": true,
      "consent_purpose": "For bank account purpose only",
      "name": `${panDetail?.panDetail?.fullName || manualCustomerData?.fullName }`,
      "mobile": `${panDetail?.panDetail?.linkedMobileNumber || manualCustomerData?.linkedMobileNumber }`,
      "inquiry_purpose": "PL",
      "partyId": `${orderData.customerPartyId}`,
      "verificationId": `${orderData.id}`
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/credit-report`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data: data
    };

    axios.request(config)
      .then((response) => {
        if ((response?.data?.comment === "Consumer not found in bureau")) {

          // setShowCreditData(false)
          setBtnLoading(false)
          toast({
            title: `${response?.data?.comment} for number - ${panDetail?.panDetail?.linkedMobileNumber ||  manualCustomerData?.linkedMobileNumber }`,
            status: 'error',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
        } else if (response?.data?.responseKey === "error_invalid_mobile") {
          setBtnLoading(false)
          toast({
            title: `Provided Mobile Number is Invalid`,
            status: 'error',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
        } else if (response?.data?.creditReport?.message === "Credit Report fetched successfully") {
          setShowCreditData(true)
          renderXyz()
          toast({
            title: `Credit Report fetched successfully`,
            status: 'success',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
          setBtnLoading(false)
        } else if (response?.data?.status === "FAILURE") {
          toast({
            title: `${response?.data?.message} [${response?.data?.responseKey}]`,
            status: 'error',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
          setBtnLoading(false)
        } else {
          toast({
            title: 'Oops we are facing some temporary issue with your request',
            status: 'error',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
          setBtnLoading(false)
        }



      })
      .catch((error) => {
        toast({
          title: `Something went wrong please try again`,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })

        setBtnLoading(false)
        console.log(error);
      });
  }

  // get report url
  useEffect(() => {
    let data = JSON.stringify({
      "orderId": `${orderData?.id}`,
      "entityId": `${orderData?.OrderPartyBankStatement[0]?.entityId || null}`
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/finbox/finbox-report-link`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()

      },
      data: data
    };

    if ((orderData?.OrderPartyBankStatement[0]?.entityId !== undefined) && (orderData?.OrderPartyBankStatement[0]?.progress !== "failed")) {
      axios.request(config)
        .then((response) => {
          setReportURL(response?.data?.statementReportUrl)
          setReportToggle(true)
        })
        .catch(() => {
          console.log('getting-error-to-fetching-report');
          setReportToggle(false)
        });
    }

  }, [orderData])

  // #### get pvt ltd name using verify documetn ###
  useEffect(() => {
    let data = JSON.stringify({
      "reference_id": "random uniques string",
      "document_type": "PAN",
      "id_number": `${pvtPan}`,
      "consent_purpose": "For bank account purpose only",
      "partyId": `${orderData.customerPartyId}`,
      "verificationId": `${orderData.id}`
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/verify-document`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data: data
    };

    axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setVerifyDocPan(response.data)
      })
      .catch((error) => {
        console.log(error);
      });
  }, [orderData, pvtPan])


  // ### MANUAL CUSTOMER DETIALS HANDLER ###
  const manualCustomer = (e) => {
    setManualCustomerData({...manualCustomerData, [e.target.name]: `${e.target.value}`})
  }

  console.log('panDetail', panDetail);

  return (
    <>

      <Box
        shadow={"md"}
        rounded={"md"}
        border={"1px"}
        borderColor={"gray.200"}
        bgColor={"#FFFFFF"}
        my={5}
        p={0}
      >
        <Flex justifyContent={'space-between'} alignItems={'center'} pr={4} mt={2}>
          {showBox ?
            <Heading size={"md"} m={4}>
              Verification Details
            </Heading>
            :
            <Heading size={"md"} m={4}>
              Download Report
            </Heading>
          }
          <Flex alignItems={'center'}>
            {/* {(bankAccount.length !== 0 || kycCategory === "PVT_LTD") && */}
            <TableToExcelCustomer  renderXyz={renderXyz} conditionForDecentro={bankAccount.length === 0} orderData={orderData} panDetail={panDetail} kycCategory={kycCategory} partyId={orderData.customerPartyId} bankAccount={bankAccount} addresses={addresses} faceMatch={cData.PartyFaceMatch.filter((x) => x?.kycCategory === kycCategory)[cData.PartyFaceMatch.filter((x) => x?.kycCategory === kycCategory).length - 1]} panDetails={panDetail} creditScoreData={creditScoreData} />
            {/* } */}
            {(reportURL.length > 0 && reportToggle) &&
              <Tooltip label='Download Finbox Report'>
                <Link to={reportURL}>
                  <SiMicrosoftexcel color={'#10743f'} fontSize={'28px'} />
                </Link>
              </Tooltip>
            }
            {orderData?.OrderPartyBankStatement[0]?.progress === "failed" && <Tooltip label='Download Finbox Report'>
              <Tooltip label='Finbox report progress is failed from finbox side'>
                {/* <Link to={'#'} isDisabled={true}> */}
                <Text as={'span'} cursor={'not-allowed'}>
                  <SiMicrosoftexcel color={'#b31312'} fontSize={'28px'} />
                </Text>
                {/* </Link> */}
              </Tooltip>
            </Tooltip>}

          </Flex>
        </Flex>


        {showBox &&
          <>
            <Divider size={1} mt={2} borderBottomColor={"black"} />
            {/* Table Container */}
            <Box>
            

            <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  Profession
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                  {panDetail?.kycCategory || "Profession is not available"}
                </Text>
              </Flex>

              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  CR Full Name
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                  {panDetail?.panDetail?.fullName}
                </Text>
              </Flex>
           
              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  CR DOB
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                  {panDetail?.panDetail?.dob || "Date of birth is not available"}
                </Text>
              </Flex>
              {/* PAN phone number */}
              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  PAN Linked Mobile Number
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                  {panDetail?.panDetail?.linkedMobileNumber || "n/a"}
                </Text>
              </Flex>

              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  Credit Score
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                  {creditScore?.creditScore || "Credit score is not available"}
                </Text>
              </Flex>

              {
                partyContent.map((x) => {
                  return (
                    x ? (
                    <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                      <Text
                        fontSize={"16px"}
                        flexBasis={"40%"}
                        borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                        p={2}
                        pl={4}
                        fontWeight={"semibold"}
                      >
                        {x?.contentTypeEnumId}
                      </Text>
                      <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                        {x?.contentUrl || "Not Available"}
                      </Text>
                    </Flex>) : null
                  )
                })
              }

              {/* GET DECENTRO CREDIT DETAILS */}
              {(bankAccount.length === 0 && kycCategory !== "PVT_LTD") &&
                <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                  <Text
                    fontSize={"16px"}
                    flexBasis={"40%"}
                    borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                    p={2}
                    pl={4}
                    fontWeight={"semibold"}
                  >
                    Credit Report
                  </Text>
                  <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4} >
                    {btnLoading ?
                      <Spinner
                        color='blue.500'
                        size='sm'
                        mt={1}
                        ml={5}
                      />
                      :
                      <Button size={'xs'} colorScheme={'yellow'} onClick={panDetail?.panDetail?.linkedMobileNumber ? creditHandler : onOpen}>Fetch Credit Report</Button>
                    }
                  </Text>
                </Flex>
              }
              {/* ------------- Address ------------ */}
              {bankAccount.length > 0 &&
                <>
                  {bankAccount.length > 0 ? (
                    addresses.map((e, i) => {
                      return (
                        <Flex key={i} borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                          <Text
                            fontSize={"16px"}
                            flexBasis={"40%"}
                            borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                            p={2}
                            pl={4}
                            fontWeight={"semibold"}
                          >
                            Address {i + 1}
                          </Text>
                          <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                            {e.addressline1 +
                              ", " +
                              e.state +
                              ", " +
                              e.country +
                              ", " +
                              e.pincode}
                          </Text>
                        </Flex>
                      );
                    })
                  ) : (
                    <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                      <Text
                        fontSize={"16px"}
                        flexBasis={"40%"}
                        borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                        p={2}
                        pl={4}
                        fontWeight={"semibold"}
                      >
                        Address
                      </Text>
                      <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                        Address is not available
                      </Text>
                    </Flex>
                  )}

                  <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                    <Text
                      fontSize={"16px"}
                      flexBasis={"40%"}
                      borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                      p={2}
                      pl={4}
                      fontWeight={"semibold"}
                    >
                      Email Id
                    </Text>
                    <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                      {/* {creditData?.creditReport?.data?.cCRResponse?.cIRReportDataLst[0]?.cIRReportData?.iDAndContactInfo?.emailAddressInfo[0]?.emailAddress}
               */}
                      {cData?.email}
                    </Text>
                  </Flex>
                  {/* Account - 1 & Account - 2 & Account ....*/}
                  {/* Heading */}
                  {bankAccount.length > 0 ? bankAccount.map((e, i) => {
                    return (
                      <Box key={i}>
                        <Heading
                          width={"40%"}
                          fontSize={"16px"}
                          borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                          p={3}
                          pl={4}
                          pb={1}
                          fontWeight={"semibold"}
                        >
                          Accounts {i + 1}
                        </Heading>
                        {/* Table value TD */}
                        <Box width={"96%"} marginLeft={"auto"}>
                          <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                            <Text
                              fontSize={"15px"}
                              flexBasis={"37.5%"}
                              borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                              p={2}
                              pl={0}
                            >
                              Credit Limit
                            </Text>
                            <Text fontSize={"15px"} flexBasis={"62.5%"} p={2} pl={4}>
                              {e?.creditLimit || '----'}
                            </Text>
                          </Flex>
                          <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                            <Text
                              fontSize={"15px"}
                              flexBasis={"37.5%"}
                              borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                              p={2}
                              pl={0}
                            >
                              Account Type
                            </Text>
                            <Text fontSize={"15px"} flexBasis={"62.5%"} p={2} pl={4}>
                              {e?.decentroAccountType || '----'}
                            </Text>
                          </Flex>
                          <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                            <Text
                              fontSize={"15px"}
                              flexBasis={"37.5%"}
                              borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                              p={2}
                              pl={0}
                            >
                              Ownership Type
                            </Text>
                            <Text fontSize={"15px"} flexBasis={"62.5%"} p={2} pl={4}>
                              {e?.ownershipType || '----'}
                            </Text>
                          </Flex>
                        </Box>
                        <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                          <Text
                            fontSize={"15px"}
                            flexBasis={"40%"}
                            borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                            p={2}
                            pl={"4%"}
                          >
                            Term Frequency
                          </Text>
                          <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                            {e?.termFrequency || '----'}
                          </Text>
                        </Flex>
                      </Box>
                    )
                  }) :
                    (
                      <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                        <Text
                          fontSize={"16px"}
                          flexBasis={"40%"}
                          borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                          p={2}
                          pl={4}
                          fontWeight={"semibold"}
                        >
                          Account
                        </Text>
                        <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                          Account is not available
                        </Text>
                      </Flex>
                    )
                  }

                  <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                    <Text
                      fontSize={"16px"}
                      flexBasis={"40%"}
                      borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                      p={2}
                      pl={4}
                      fontWeight={"semibold"}
                    >
                      Credit Score
                    </Text>
                    <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4} fontWeight={"semibold"}>
                      {creditScoreData.lenght === 0 ?
                        "Credit score is not available"
                        : <>{creditScoreData[0].creditScore}</>
                      }
                    </Text>
                  </Flex>
                </>
              }

              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  Average Bank Balance
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4} fontWeight={orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits !== undefined && 'semibold'}>
                  {orderData?.OrderPartyBankStatement[0]?.averageBankBalance !== undefined ?
                    <>
                      ₹{Number(orderData?.OrderPartyBankStatement[0]?.averageBankBalance).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </>
                    :
                    <>
                      Average bank balance is not available
                    </>
                  }
                </Text>
              </Flex>

              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  Average Monthly Income
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4} fontWeight={orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits !== undefined && 'semibold'}>
                  {orderData?.OrderPartyBankStatement[0]?.averageMonthlyIncome !== undefined ?
                    <>
                      ₹{Number(orderData?.OrderPartyBankStatement[0]?.averageMonthlyIncome).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </>
                    :
                    <>
                      Average monthly income is not available
                    </>
                  }
                </Text>
              </Flex>

              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  Average Monthly Debits
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4} fontWeight={orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits !== undefined && 'semibold'}>
                  {orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits !== undefined ?
                    <>
                      ₹{Number(orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </>
                    :
                    <>
                      Average monthly debits is not available
                    </>
                  }
                </Text>

              </Flex>


              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  Current Inward Cheque Bounce Credit
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4} fontWeight={orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits !== undefined && 'semibold'}>
                  {orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits !== undefined ?
                    <>
                      ₹{Number(orderData?.OrderPartyBankStatement[0]?.currentChequeBounceCredit).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </>
                    :
                    <>
                      Current inward cheque bounce credit is not available
                    </>
                  }
                </Text>
              </Flex>


              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  Statement Start Date
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4} fontWeight={orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits !== undefined && 'semibold'}>
                  {orderData?.OrderPartyBankStatement[0]?.statementStartDate !== null ?
                    <>
                      {new Date(orderData?.OrderPartyBankStatement[0]?.statementStartDate).toLocaleDateString('en-IN')}
                    </>
                    :
                    <>
                      Statement start date is not available
                    </>
                  }
                </Text>
              </Flex>

              <Flex borderBottom={"1px solid rgba(0, 0, 0, 0.3)"}>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  Statement End Date
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4} fontWeight={orderData?.OrderPartyBankStatement[0]?.averageMonthlyDebits !== undefined && 'semibold'}>
                  {orderData?.OrderPartyBankStatement[0]?.statementEndDate !== null ?
                    <>
                      {new Date(orderData?.OrderPartyBankStatement[0]?.statementEndDate).toLocaleDateString('en-IN')}
                    </>
                    :
                    <>
                      Statement end date is not available
                    </>
                  }
                </Text>
              </Flex>

              <Flex>
                <Text
                  fontSize={"16px"}
                  flexBasis={"40%"}
                  borderRight={"1px solid rgba(0, 0, 0, 0.3)"}
                  p={2}
                  pl={4}
                  fontWeight={"semibold"}
                >
                  FaceMatch Percent
                </Text>
                <Text fontSize={"15px"} flexBasis={"60%"} p={2} pl={4}>
                  {cData.PartyFaceMatch.filter((x) => x?.kycCategory === kycCategory)[cData.PartyFaceMatch.filter((x) => x?.kycCategory === kycCategory).length - 1]?.score || "Face Match is not available"}
                </Text>
              </Flex>


            </Box>
          </>
        }

        {/* Manual Credit report modal */}
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Generate Credit Report Manually</ModalHeader>
            <ModalCloseButton />
            <ModalBody>

              <FormControl mt={4} >
                <FormLabel>Customer Full Name<Text as={'span'} color={'red.500'}>*</Text></FormLabel>
                <Input placeholder='Enter customer full name' name='fullName' onChange={manualCustomer} autoComplete="off" />
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>PAN Linked Mobile Number<Text as={'span'} color={'red.500'}>*</Text></FormLabel>
                <Input placeholder='Enter customer pan linked mobile number' name='linkedMobileNumber' onChange={manualCustomer} autoComplete="off"/>
              </FormControl>

            </ModalBody>

            <ModalFooter>
              <Button colorScheme='red' mr={3} onClick={onClose}>
                Cancle
              </Button>
              <Button colorScheme='blue' onClick={() => {
              onClose()
              creditHandler()
              }}>Generate</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default CustomerDetails;
